import { render } from "./Upload.vue?vue&type=template&id=ca5be010&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=ca5be010&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ca5be010"

export default script